<template>
  <div
    class="relative flex mb-3"
    :class="[
      isUserMessage ? 'justify-end' : 'justify-start'
    ]"
  >

    <div
      v-if="isUserMessage"
      class="absolute -right-3 -top-3 w-7 h-7 rounded-full overflow-hidden z-10 shadow border border-white"
    >
      <img :src="avatar" alt="User" class="w-full h-full object-cover" />
    </div>

    <div
      v-else
      class="absolute -left-3 -top-3 w-7 z-10 overflow-hidden z-10"
      style="display: flex; justify-content: center; align-items: center; padding: 1px;"
    >
      <img :src="avatar" alt="Scout" class="max-w-full max-h-full object-contain" />
    </div>

    <div
      :class="['flex flex-col', 'w-[90%]', isUserMessage ? 'mr-2' : 'ml-2']"
    >
      <div
        :class="[
          'rounded-xl p-2.5 relative overflow-x-auto',
          isUserMessage
            ? 'user-dialog bg-gpx_terracotta-900'
            : 'ai-dialog bg-gpx_gray-900'
        ]"
      >
        <MessageContent :content="message.content" :id="message.id" />
        <MessageFiles v-if="message.files && message.files.length > 0" :files="message.files" />
        <div class="text-xs opacity-50 mt-1 text-right text-gpx_gray-200">
          {{ formatTime(message.created_at) }}
        </div>
      </div>
      <MessageActions v-if="isFinalAiMessage" :message="message" :dialog-id="message.dialog_id" @feedback-updated="$emit('feedbackUpdated', $event)" class="mt-2" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MessageContent from './MessageContent.vue';
import MessageFiles from './MessageFiles.vue';
import { format, fromUnixTime } from 'date-fns';
import { enUS } from 'date-fns/locale';
import MessageActions from './MessageActions.vue';

const props = defineProps({
  message: {
    type: Object,
    required: true
  },
  avatar: {
    type: String,
    required: true
  },
  isFinalAiMessage: {
    type: Boolean,
    default: false
  }
});

const isUserMessage = computed(() => props.message.role === 'user');

// Format time using date-fns
function formatTime(timestamp) {
  if (!timestamp) return '';

  try {
    // Convert UNIX timestamp to Date object using date-fns
    const date = fromUnixTime(timestamp);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Format time using date-fns format function with US locale
    return format(date, 'h:mm a', { locale: enUS });
  } catch (error) {
    console.error('Error formatting time:', error);
    return '';
  }
}
</script>
